module.exports = __webpack_public_path__ + "18fae7d11872421f8c3d85e85d9643f2.png";